var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect } from 'react';
import { useFetchers } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { last } from 'lodash';
import { Translate } from "../../../../I18N";
import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { notificationAtom } from "../../../atoms";


const useHandleNotifications = () => {var _lastFetcherCall$form;
  const fetchers = useFetchers();
  const setNotifications = useSetAtom(notificationAtom);

  const lastFetcherCall = last(fetchers) || fetchers[0];
  const intent = lastFetcherCall === null || lastFetcherCall === void 0 ? void 0 : (_lastFetcherCall$form = lastFetcherCall.formData) === null || _lastFetcherCall$form === void 0 ? void 0 : _lastFetcherCall$form.get('intent');
  const { data } = lastFetcherCall || {};

  useEffect(() => {
    if (!intent || !data) return;

    if (data instanceof FetchResponseError) {var _data$json;
      const message = (_data$json = data.json) !== null && _data$json !== void 0 && _data$json.prettyMessage ? data.json.prettyMessage : data.message;

      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: message || undefined
      });

      return;
    }

    let text;

    switch (intent) {
      case 'new-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Added new user");
        break;

      case 'edit-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "User updated");
        break;

      case 'new-group':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Group saved");
        break;

      case 'edit-group':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Group updated");
        break;

      case 'delete-users':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted user");
        break;

      case 'delete-groups':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Deleted user group");
        break;

      case 'unlock-user':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Account unlocked successfully");
        break;

      case 'reset-password':
      case 'bulk-reset-password':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Instructions to reset the password were sent to the user");
        break;

      case 'reset-2fa':
      case 'bulk-reset-2fa':
        text = /*#__PURE__*/_jsx(Translate, {}, void 0, "Disabled 2FA");
        break;

      default:
        break;
    }

    if (text) {
      setNotifications({
        type: 'success',
        text
      });
    }
  }, [data, intent, setNotifications]);
};

export { useHandleNotifications };